import { connect } from 'react-redux';
import CashActionDetails from './CashActionDetails';
import { mapStateToProps, mapDispatchToProps } from './CashActionDetails.state';

export default connect(mapStateToProps, mapDispatchToProps)(CashActionDetails);
